/**
 * Traductions injectées par le shell Twig dans window.__P4N__.messages
 * (dictionnaire clé gettext -> traduction dans la locale courante).
 */
const bootstrap = window.__P4N__ || {};
const messages = bootstrap.messages || {};

export function t(key) {
    return messages[key] || key;
}

export const locale = bootstrap.locale || 'fr';
export const basename = bootstrap.basename || '';
export const user = bootstrap.user || null;

/**
 * Formate une date selon la langue de l'interface (locale courante).
 * Accepte une string 'YYYY-MM-DD' / ISO ou un objet Date.
 * Les dates au format 'YYYY-MM-DD' sont parsées en heure LOCALE (composants
 * explicites) pour éviter le décalage d'un jour dû à l'interprétation UTC.
 * Renvoie '' pour une valeur vide, et la valeur brute si elle est invalide.
 *
 * @param {string|Date|null} value
 * @param {Intl.DateTimeFormatOptions} [opts] Options passées à toLocaleDateString
 */
export function formatDate(value, opts) {
    if (!value) return '';
    let date;
    const match = typeof value === 'string' && value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) {
        date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    } else {
        date = value instanceof Date ? value : new Date(value);
    }
    if (Number.isNaN(date.getTime())) return typeof value === 'string' ? value : '';
    return date.toLocaleDateString(locale, opts);
}
